import RecoverStep from "./recover_step";
import {startRunbook} from "../utils/recover_utils";
import {convertAutoStopValueToMinutes} from "../../../modules/helpers/vo-helper";

const TEMPLATE = 'virtualization-start-runbook-warning';

export default class StartRunbookWarning extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    transitionStart(data, el, fr) {
        const runbookId = data.recovery.virtualization.runbook.id;
        const runbookPassword = data.recovery.virtualization.runbook.password;

        startRunbook(
          fr,
          data.clientId,
          runbookId,
          data.recovery.virtualization.type,
          runbookPassword,
          convertAutoStopValueToMinutes(data.recovery.virtualization.autoStopValue),
          function (rv, status) {
              fr.goTo('createRunbookFailover');
          },
          function (rv, status) {
              $.extend(data.render, {
                  hasError: true,
                  errors: rv.errors
              });
              fr.render('startRunbookWarning');
          }
        );
    }


    postRender(data, el, fr) {
        const $el = $(el);
        alignHeaderOnLimitedHeightTable($el);
        $el.find('.js-configure_runbook a').click(function () {
            fr.close();
            tabs_goto('client/runbooks/' + data.clientId);
        });
    }

}
